<template>
  <div
    :class="[
      $style.gamesCatalogueWrapper,
      { [$style.gamesCatalogueWrapperNoMargin]: isDefaultCollection },
    ]"
  >
    <div
      v-if="catalogueTitle || isShowFiltersAndSort"
      :class="[
        $style.gamesCatalogueWrapperTitleHolder,
        {
          [$style.gamesCatalogueWrapperTitleHolderNoMargin]:
            !catalogueTitle && isFavoritsCollection,
        },
      ]"
    >
      <CatalogueHeader
        v-if="catalogueTitle && !isFavoritsCollection"
        no-navigation
        no-show-all-button
        :class="$style.gamesCatalogueWrapperTitle"
        :icon="catalogueIcon ? catalogueIcon.url : undefined"
        :name="catalogueTitle"
      />
      <div v-if="isShowFiltersAndSort" :class="$style.gameFilterSortBlock">
        <div v-if="isShowProviderFilter" :class="$style.gameFilterBlock">
          <BitTabButton
            :class="$style.btnFilters"
            :active="isShowProvidersFilterDropdown"
            @click="toggleProvidersFilter"
          >
            <template #appendIcon>
              <img src="/images/common/providerSearch.svg?url_encode" alt="" />
            </template>
            <template #prependIcon>
              <img src="/images/common/ico_dropdown_arrow_down.svg?url_encode" alt="" />
            </template>
            {{ providerFilterTitle }}
          </BitTabButton>
          <SearchProviderFilter
            v-if="isShowProvidersFilterDropdown"
            :providers="gamesDataListProvidersCount"
            :selected-providers="selectedProviders"
            :filter-title="storeCataloguePage.allProvidersTitle"
            is-catalogue-page
            position="bottom"
            @close="closeProvidersFilter"
            @selected="selectedProvidersHandle"
          />
        </div>

        <BitSelect
          v-model="currentSort"
          :class="$style.selectedProvider"
          :placeholder="storeComponents.sortProvider.placeholderSort"
          is-no-margin
          variant="filter"
          :options="gameSortOptions"
        >
          <template #appendInputIcon>
            <img src="/images/common/ico_sorting.svg?url_encode" />
          </template>
        </BitSelect>
      </div>
    </div>

    <div v-if="formatedSelectedProviders.length" :class="$style.providerFiltersList">
      <BitChipsTabButton
        v-for="provider in formatedSelectedProviders"
        :key="provider.originalName"
        :class="$style.providerFiltersListButton"
        @click="removeSelectProviderByName(provider.originalName)"
      >
        <img
          :src="provider.icon"
          :alt="provider.name"
          :class="$style.providerIcon"
          height="16"
          width="16"
        />
        {{ provider.name }}
      </BitChipsTabButton>
      <BitLinkButton tag="button" @click="removeAllProviderFilters">
        {{ storeComponents.sortProvider.btnClearAll }}
      </BitLinkButton>
    </div>

    <div v-if="isDefaultCollection" :class="$style.gamesCatalogueContentDefault">
      <MainPageCatalogueCarousel
        :collections="storeCategoryPage.gameRowsCategories"
        :show-all-title="storeCataloguePage.showAllGamesTitle"
        :data-show-more-title="storeButtonTitles.showMoreGames"
        :gtm-action="gtmAction"
      />
    </div>
    <MyGamesCategory
      v-else-if="isFavoritsCollection"
      :class-for-container="$style.gamesCatalogueContent"
      :gtm-action="gtmAction"
      :suggestion-collection="collectionHits"
      @addToFavorite="addToFavorite"
      @removeFromFavorite="removeFromFavorite"
      @setCountCatalogueItem="setCountCatalogueItem"
    />
    <MainPageCatalogueContainer
      v-else
      :class="$style.gamesCatalogueContent"
      :games-list="gamesDataListFormatted"
      :gtm-action="gtmAction"
      :gtm-data="{ event: 'game_open', event_label: '' }"
      :favorite-games="favoriteGames"
      :is-loading="!isGamesLoaded"
      @addToFavorite="addToFavorite"
      @removeFromFavorite="removeFromFavorite"
      @setCountCatalogueItem="setCountCatalogueItem"
    />
    <div
      v-if="
        gamesDataList &&
        isMoreGames &&
        isGamesLoaded &&
        !isDefaultCollection &&
        !isFavoritsCollection
      "
      :class="$style.gamesCatalogueShowMore"
    >
      <BitButton type="secondary" @click="showMoreGames()">
        {{ storeButtonTitles.showMoreGames }}
      </BitButton>
    </div>
    <div v-else-if="isNoGames && !isDefaultCollection">
      <p :class="$style.gamesCatalogueNoGames">
        {{ storeCataloguePage.noGamesTitle }}
      </p>
      <CatalogueRow
        :collection="collectionHits"
        :games-list="hitsGames"
        :show-all-title="storeCataloguePage.showAllGamesTitle"
        :gtm-action="gtmAction"
        :header-text="storeCataloguePage.noGamesButWeRecommendForYou"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitButton, BitSelect, BitTabButton, BitChipsTabButton, BitLinkButton } from '@bit/ui-kit';
import MainPageCatalogueCarousel from '~/components/mainPage/catalogueCarousel.vue';
import MainPageCatalogueContainer from '~/components/mainPage/catalogueContainer.vue';
import CatalogueRow from '~/components/mainPage/catalogueRow.vue';
import CatalogueHeader from '~/components/mainPage/catalogueSliderHeader.vue';
import MyGamesCategory from '~/components/mainPage/myGamesCategory.vue';
import SearchProviderFilter from '~/components/mainPage/searchProviderFilter.vue';
import { useLoadSliderGames } from '~/composables/useLoadSliderGames';
import { useStoreModals } from '~/stores/abstract/modals';
import { useStoreRoot } from '~/stores/abstract/root';
import { useGamesFiltersStore } from '~/stores/client/gamesFilters';
import { useStoreMenuStatuses } from '~/stores/client/menuStatuses';
import { useStoreSsGames } from '~/stores/softswiss/games';
import { useStoreSsGamesFavourite } from '~/stores/softswiss/gamesFavourite';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import { useStoreCataloguePage } from '~/stores/strapi/cataloguePage';
import { useStoreCategoryPage } from '~/stores/strapi/categoryPage';
import { useStoreComponents } from '~/stores/strapi/components';
import { useStoreCurrencyMenu } from '~/stores/strapi/currencyMenu';
import { useStoreProviders } from '~/stores/strapi/providers';
import { useStoreSlotTheme } from '~/stores/strapi/slotThemes';
import { eGameSort } from '~/types/gamesSortAndFilters';
import { EPageType } from '~/types/pageType';
import { debounce } from '~/utils/debounce';
import type { IGamesRequestOptions, ISsGame } from '~/types/softswiss/ssGames';
import type { IStrapiImage } from '~/types/strapiImage';

const props = defineProps({
  pageType: {
    type: String,
    required: false,
    default: () => '',
  },
});

const route = useRoute();
// const router = useRouter();
const storeCategoryPage = useStoreCategoryPage();
const storeSlotTheme = useStoreSlotTheme();
const storeSsGames = useStoreSsGames();
const storeCataloguePage = useStoreCataloguePage();
const storeSsPlayer = useStoreSsPlayer();
const storeRoot = useStoreRoot();
const storeSsGamesFavourite = useStoreSsGamesFavourite();
const storeProviders = useStoreProviders();
const storeButtonTitles = useStoreButtonTitles();
const storeModals = useStoreModals();
const storeCurrencyMenu = useStoreCurrencyMenu();
const storeComponents = useStoreComponents();
const storeGamesFilters = useGamesFiltersStore();
const storeMenuStatuses = useStoreMenuStatuses();
const { loadCollectionGames } = useLoadSliderGames();

const offsetCount = ref(0);
const gamesCount = ref<number>(NaN);
const pageCount = ref<number>(NaN);
const isGamesLoaded = ref<boolean>(false);
const gamesDataList = ref<ISsGame[]>([]);
const gamesDataListMeta = ref<any>(null);
const hitsGames = ref<ISsGame[] | null>(null);
const catalogueTitle = ref('');
const catalogueIcon = ref<null | IStrapiImage>(null);
const currentSort = ref(eGameSort.Default);
const isShowProvidersFilterDropdown = ref(false);
const selectedProviders = ref<string[]>([]);
const selectedProvidersDraft = ref<string[]>([]);
const gamesDataListProvidersCount = ref<Record<string, number>>({});

const isDefaultCollection = computed(
  () =>
    storeCataloguePage.selectedCollection === storeCataloguePage.defaultCollection &&
    storeCataloguePage.selectedProvider === ''
);

const isFavoritsCollection = computed(() => storeCataloguePage.selectedCollection === 'favorites');

const collectionHits = computed(() => {
  const hits = storeCategoryPage.gameCategories?.find((item) => item.categoryId === 'hits');
  return {
    id: hits?.categoryId,
    name: hits?.categoryTitle,
    icon: hits?.categoryMenuIcon,
  };
});

const isNoGames = computed(() => !gamesDataList.value.length && isGamesLoaded.value);

const isMoreGames = computed((): boolean => {
  if (isFavoritsCollection.value && !storeSsGamesFavourite.gameIds.length) {
    return false;
  }

  if (gamesDataList.value && gamesDataList.value.length && gamesDataListMeta.value) {
    return gamesCount.value < gamesDataListMeta.value.total;
  }

  return false;
});

const gtmAction = computed((): string => {
  if (storeCataloguePage.selectedProvider) {
    return 'provider_' + storeCataloguePage.selectedProvider;
  }

  return (
    'collection_' + (storeCataloguePage.selectedCollection || storeCataloguePage.defaultCollection)
  );
});

const formatedSelectedProviders = computed(() => {
  return selectedProviders.value.map((provider) => {
    const providerData = storeProviders.activeList.find((p) => p.providerId === provider);
    return {
      originalName: provider,
      name: providerData?.providerTitle || provider,
      icon:
        providerData?.providerIcon?.url ||
        `/image-cdn/ss/logos/providers_small/color/${provider}.svg`,
    };
  });
});

const providerFilterTitle = computed(() => {
  if (!selectedProviders.value.length) {
    return storeComponents.sortProvider.filterByText;
  }
  if (selectedProviders.value.length === 1) {
    return formatedSelectedProviders.value[0].name;
  }

  return storeComponents.sortProvider.itemsSelectedText;
});
const gameSortOptions = computed(() => {
  return {
    [eGameSort.Default]: storeComponents.sortProvider.default,
    [eGameSort.NameAlphabet]: storeComponents.sortProvider.nameAlphabet,
    [eGameSort.NameAlphabetRevers]: storeComponents.sortProvider.nameAlphabetRevers,
    [eGameSort.New]: storeComponents.sortProvider.sortNew,
  };
});

const isShowFiltersAndSort = computed(() => {
  return (
    ((storeCataloguePage.selectedCollection && !isDefaultCollection.value) ||
      storeCataloguePage.selectedProvider) &&
    !isFavoritsCollection.value
  );
});
const isShowProviderFilter = computed(() => {
  return (
    storeCataloguePage.selectedCollection &&
    !isDefaultCollection.value &&
    !storeCataloguePage.selectedProvider
  );
});

const favoriteGames = computed(() => storeSsGamesFavourite.gameIds);
const addToFavorite = storeSsGamesFavourite.addToFavorite;
const removeFromFavorite = storeSsGamesFavourite.removeFromFavorite;

const sortFilterDataForRequest = computed(() => {
  const sortData: { sortBy?: string; order?: 'ASC' | 'DESC'; provider?: string } = {};
  switch (currentSort.value) {
    case eGameSort.NameAlphabet:
      sortData.sortBy = 'title';
      sortData.order = 'ASC';
      break;
    case eGameSort.NameAlphabetRevers:
      sortData.sortBy = 'title';
      sortData.order = 'DESC';
      break;
    case eGameSort.New:
      sortData.sortBy = 'new';
      sortData.order = 'ASC';
      break;
    default:
      break;
  }

  if (storeCataloguePage.selectedProvider) {
    sortData.provider = storeCataloguePage.selectedProvider;
  } else if (selectedProviders.value.length) {
    sortData.provider = selectedProviders.value.join(',');
  }

  return sortData;
});

const isMobile = computed(() => usePlatform().isMobile);

const closeProvidersFilter = () => {
  isShowProvidersFilterDropdown.value = false;
  if (isMobile.value) {
    storeMenuStatuses.toggleProvidersFilterMenu(false);
  }
};

const selectedProvidersHandle = (providers: string[]) => {
  selectedProvidersDraft.value = providers;
  selectedProviders.value = [...providers];
};

const removeSelectProviderByName = (name: string) => {
  selectedProviders.value = selectedProviders.value.filter((selectedName) => name !== selectedName);
  selectedProvidersDraft.value = selectedProviders.value;
};
const removeAllProviderFilters = () => {
  selectedProviders.value = [];
  selectedProvidersDraft.value = selectedProviders.value;
};

const showMoreGames = (): void => {
  gamesCount.value += pageCount.value;
  loadPaginateGamesDataList();
};

const loadGames = async (additionalParams?: IGamesRequestOptions) => {
  let params: IGamesRequestOptions = {
    limit: pageCount.value,
  };

  const pageId = route.params.pageId as string;

  if (pageId === 'recommended-games' && !storeSsPlayer.isPlayerAuthorised) {
    await navigateTo(storeRoot.localePath('/'));
  }

  if (
    storeSsPlayer.isPlayerAuthorised &&
    storeCurrencyMenu.isFiatCurrency(storeRoot.userCurrency)
  ) {
    params.currency = storeSsPlayer.playerInfo.currency;
  }

  if (storeCataloguePage.selectedProvider) {
    params.provider = storeCataloguePage.selectedProvider;
  }

  if (
    storeCataloguePage.selectedCollection &&
    storeCataloguePage.selectedCollection !== storeCataloguePage.defaultCollection &&
    !isFavoritsCollection.value
  ) {
    params.collection = storeCataloguePage.selectedCollection;
  }

  params = { ...params, ...additionalParams };

  return await storeSsGames.loadGames(params);
};

const loadGamesWithFavoritesReload = async (params?: {
  reloadExistingGames?: boolean;
  isWithReset?: boolean;
}) => {
  isGamesLoaded.value = false;
  const { sortBy, order, provider } = sortFilterDataForRequest.value;

  const additionalParams: IGamesRequestOptions = {
    includeProvidersCount: true,
  };

  if (sortBy) {
    additionalParams.sortBy = sortBy;
  }
  if (order) {
    additionalParams.order = order;
  }
  if (provider) {
    additionalParams.provider = provider;
  }
  if (params?.reloadExistingGames) {
    additionalParams.limit = offsetCount.value;
  }
  if (params?.isWithReset) {
    gamesCount.value = pageCount.value;
    offsetCount.value = NaN;
  }

  const { data, meta, providersCount } = await loadGames(additionalParams);
  isGamesLoaded.value = true;

  gamesDataList.value = data;
  gamesDataListMeta.value = meta;
  gamesDataListProvidersCount.value = providersCount || {};
  if (gamesDataList.value?.length && !params?.reloadExistingGames) {
    offsetCount.value = pageCount.value;
  } else if (collectionHits.value?.id && !params?.reloadExistingGames) {
    hitsGames.value = await loadCollectionGames(collectionHits.value?.id);
  }
};

const debouncedLoadGames = debounce(loadGamesWithFavoritesReload, 1000);

const loadPaginateGamesDataList = async () => {
  const params: IGamesRequestOptions = {
    offset: offsetCount.value,
  };

  const { sortBy, order, provider } = sortFilterDataForRequest.value;

  if (sortBy) {
    params.sortBy = sortBy;
  }
  if (order) {
    params.order = order;
  }
  if (provider) {
    params.provider = provider;
  }

  const { data, meta } = await loadGames(params);

  gamesDataList.value?.push(...data);

  if (meta) {
    gamesDataListMeta.value = meta;
  }
  if (selectedProviders.value.length === 0 && currentSort.value === eGameSort.Default) {
    storeCategoryPage.setCategoryDataList(route.path, {
      gamesCount: gamesCount.value,
      games: gamesDataList.value,
      gamesMeta: gamesDataListMeta.value,
      gamesPerPage: pageCount.value,
      providersCount: gamesDataListProvidersCount.value || {},
    });
  }

  offsetCount.value += pageCount.value;
};

const setCountCatalogueItem = async (count: number) => {
  const savedDataList = storeCategoryPage.categoryDataList[route.path];
  if (savedDataList) {
    return;
  }
  gamesCount.value = count;
  pageCount.value = count;
  if (!isDefaultCollection.value) {
    await loadGamesWithFavoritesReload();
  }
};

watch(
  () => [storeRoot.userCurrency, storeSsPlayer.isPlayerAuthorised],
  async () => {
    if (!isNaN(gamesCount.value)) {
      await loadGamesWithFavoritesReload();
    }
  }
);

watch(
  () => storeSsGamesFavourite.gameIds.length,
  async () => {
    if (storeModals.activeModal?.name === 'search') {
      const { data, meta } = await loadGames();
      gamesDataList.value = data;
      gamesDataListMeta.value = meta;
    }
  },
  { immediate: true }
);

watch(
  () => selectedProviders.value,
  (val, oldVal) => {
    if (val.length === oldVal.length && val.every((v, i) => v === oldVal[i])) {
      return;
    }
    storeGamesFilters.setFilters(route.path, val);
    debouncedLoadGames({ isWithReset: true });
  }
);
watch(
  () => currentSort.value,
  (val) => {
    storeGamesFilters.setSort(route.path, val);
    loadGamesWithFavoritesReload({ reloadExistingGames: true });
  }
);

const setCatalogueTitle = () => {
  if (props.pageType === EPageType.slotTheme) {
    catalogueTitle.value =
      storeSlotTheme.list.find((c) => c.categoryId === storeCataloguePage.selectedCollection)
        ?.title || '';
  } else if (storeCataloguePage.selectedProvider) {
    catalogueTitle.value =
      storeProviders.activeList.find((p) => p.providerId === storeCataloguePage.selectedProvider)
        ?.providerTitle || '';
  } else if (storeCataloguePage.selectedCollection && !isDefaultCollection.value) {
    catalogueTitle.value =
      storeCategoryPage.activeList.find(
        (c) => c.categoryId === storeCataloguePage.selectedCollection
      )?.categoryTitle || '';
  } else {
    catalogueTitle.value = '';
  }
};

const setCatalogueIcon = () => {
  if (storeCataloguePage.selectedProvider) {
    catalogueIcon.value =
      storeProviders.activeList.find((p) => p.providerId === storeCataloguePage.selectedProvider)
        ?.providerIcon || null;
  } else if (storeCataloguePage.selectedCollection && !isDefaultCollection.value) {
    catalogueIcon.value =
      storeCategoryPage.list.find((el) => el.categoryId === storeCataloguePage.selectedCollection)
        ?.categoryMenuIcon || null;
  } else {
    catalogueIcon.value = null;
  }
};

const gamesDataListFormatted = computed(() => {
  if (isFavoritsCollection.value && gamesDataList.value?.length) {
    return storeSsGamesFavourite.gameIds
      .map((gameId) => {
        return {
          gameId,
          ...gamesDataList.value.find((g) => Object.values(g.real).some((r) => r.id === gameId)),
        };
      })
      .filter((game) => !!game.collections);
  } else {
    return gamesDataList.value.length ? gamesDataList.value : null;
  }
});

// @TODO: DO NOT FUCKING TOUCH IT, IT FIX THE BEST BROWSER IN THE WORLD MOZILLA FIREFOX

watch(
  () => [
    storeCataloguePage.selectedProvider,
    props.pageType,
    storeCataloguePage.selectedCollection,
    isDefaultCollection,
  ],
  () => {
    setCatalogueTitle();
    setCatalogueIcon();
  },
  { immediate: true, deep: true }
);

const onScrollHandler = () => {
  storeCategoryPage.setCategoryScrollPosition(window.scrollY);
};

const toggleProvidersFilter = () => {
  isShowProvidersFilterDropdown.value = !isShowProvidersFilterDropdown.value;
  if (isMobile.value) {
    storeMenuStatuses.toggleProvidersFilterMenu(isShowProvidersFilterDropdown.value);
  }
};

onBeforeMount(() => {
  if (isDefaultCollection.value) {
    isGamesLoaded.value = true;
  }
  const savedDataList = storeCategoryPage.categoryDataList[route.path];
  if (savedDataList) {
    gamesCount.value = savedDataList.gamesCount;
    offsetCount.value = savedDataList.gamesCount;
    gamesDataList.value = savedDataList.games;
    gamesDataListMeta.value = savedDataList.gamesMeta;
    pageCount.value = savedDataList.gamesPerPage;
    gamesDataListProvidersCount.value = savedDataList.providersCount;
    isGamesLoaded.value = true;
  }
  const savedSortFilters = storeGamesFilters.getConfig(route.path);
  if (savedSortFilters) {
    currentSort.value = savedSortFilters.sort;
    selectedProviders.value = [...savedSortFilters.filters];
    selectedProvidersDraft.value = [...savedSortFilters.filters];
  }
});

// router.beforeEach((to, from) => {
//   if (from.path && to.path !== from.path) {
//     storeGamesFilters.clearFilters(from.path);
//   }
// });
onMounted(() => {
  window.addEventListener('scroll', onScrollHandler);
});
onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScrollHandler);
  storeGamesFilters.clearFilters(route.path);
});
</script>

<style lang="scss" module src="./catalogue.scss"></style>
